import DeveloperServices from 'aurora-composition/services/developerServices';
import * as types from './constants';

const operationStart = () => ({
  type: types.DEVELOPERS_OPERATION_START,
});

const operationEnd = error => ({
  type: types.DEVELOPERS_OPERATION_END,
  payload: { error: error?.data?.result?.description || error?.message },
});

export const addToError = message => async dispatch => {
  dispatch({ type: types.ADD_TO_DEVELOPERS_ERROR_INITITATE });

  setTimeout(() => {
    dispatch({ type: types.ADD_TO_DEVELOPERS_ERROR, payload: { message } });
  }, 200);
};

export const fetchProjects = payload => async dispatch => {
  try {
    dispatch(operationStart());

    const projects = await DeveloperServices.fetchPropertyProjects(payload);

    dispatch({ type: types.FETCH_DEVELOPERS_PROJECTS, payload: { projects } });

    return projects;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchEscrowProjects = payload => async dispatch => {
  try {
    dispatch(operationStart());

    const body = { ...payload };
    delete body.page;
    delete body.size;

    const params = {
      size: payload.size,
      page: payload.page,
    };

    const projects = await DeveloperServices.fetchPropertyProjects(body, params);

    dispatch({ type: types.FETCH_DEVELOPERS_PROJECTS, payload: { projects } });

    return projects;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectById = id => async dispatch => {
  try {
    dispatch(operationStart());

    const project = await DeveloperServices.fetchPropertyProjectById(id);

    dispatch({
      type: types.FETCH_DEVELOPERS_PROJECTS,
      payload: { projectInformations: project?.result },
    });

    return project;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectFinancialInformation = id => async dispatch => {
  try {
    dispatch(operationStart());
    const financialSummary = await DeveloperServices.fetchProjectByFinancialSummary(id);
    const financialTransaction = await DeveloperServices.fetchProjectByFinancialTransaction(id);

    const FinancialInformation = {
      escrowAccountDetails: financialSummary.result.escrowAccountDetails,
      financialSummary: financialSummary.result.financialSummary,
      financialTransaction: financialTransaction.result.financialTransactions,
      financialDocumentExists: financialSummary.result.financialDocumentExists,
      escrowAccountExist: financialSummary.result.escrowAccountExist,
      escrowAgreementExist: financialSummary.result.escrowAgreementExist,
    };
    dispatch({
      type: types.FETCH_DEVELOPERS_PROJECTS_FINANCIAL,
      payload: { financialInformation: FinancialInformation },
    });

    return financialSummary;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectProgressReport = id => async dispatch => {
  try {
    dispatch(operationStart());
    const progressReport = await DeveloperServices.fetchProjectByProgressReport(id);

    dispatch({
      type: types.FETCH_DEVELOPERS_PROGRESS_REPORT,
      payload: { progressReport: progressReport?.result },
    });

    return progressReport?.result;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};
export const fetchProjectLatestProgressReport = id => async dispatch => {
  try {
    dispatch(operationStart());
    const latestProgressReport = await DeveloperServices.fetchProjectByLatestProgressReport(id);

    dispatch({
      type: types.FETCH_DEVELOPERS_LATEST_PROGRESS_REPORT,
      payload: { latestProgressReport: latestProgressReport?.result },
    });

    return latestProgressReport?.result;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectServicesCharges = id => async dispatch => {
  try {
    dispatch(operationStart());
    const servicesCharges = await DeveloperServices.fetchProjectByServiceCharges(id);

    dispatch({
      type: types.FETCH_DEVELOPERS_SERVICES_CHARGES,
      payload: { serviceCharges: servicesCharges?.result },
    });

    return servicesCharges?.result;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectServicesChargesGroups = id => async dispatch => {
  try {
    dispatch(operationStart());
    const servicesChargesGroups = await DeveloperServices.fetchProjectByServiceChargesGroups(id);

    dispatch({
      type: types.FETCH_DEVELOPERS_SERVICES_CHARGES_GROUPS,
      payload: { serviceChargesGroups: servicesChargesGroups?.result },
    });

    return servicesChargesGroups?.result;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectByServiceChargesGroupData = (id, groupId) => async dispatch => {
  try {
    dispatch(operationStart());
    const servicesChargesGroupData = await DeveloperServices.fetchProjectByServiceChargesGroupData(id, groupId);

    dispatch({
      type: types.FETCH_DEVELOPERS_SERVICES_CHARGES_GROUP_DATA,
      payload: {
        servicesChargesGroupData: {
          [groupId]: servicesChargesGroupData?.result,
        },
      },
    });

    return servicesChargesGroupData?.result;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchProjectUnits = id => async dispatch => {
  try {
    dispatch(operationStart());
    const projectunit = await DeveloperServices.fetchProjectUnits(id);

    dispatch({
      type: types.FETCH_DEVELOPERS_PROJECT_UNIT,
      payload: { projectUnit: projectunit?.result },
    });

    return projectunit?.result;
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const downloadTransaction = id => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_TRANSACTION });
    const response = await DeveloperServices.downloadTransaction(id);
    if (response.success) {
      const { result } = response;
      if (!result.bytes || result.bytes == null) {
        dispatch({
          type: types.DOWNLOAD_TRANSACTION_ERROR,
          payload: {
            error: 'Oops! Something went wrong',
          },
        });
        return;
      }
      const fileURL = `data:${result.fileExtension};base64,${result.bytes}`;
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', result.fileName);
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      dispatch({ type: types.DOWNLOAD_TRANSACTION_SUCCESS });
    } else {
      dispatch({
        type: types.DOWNLOAD_TRANSACTION_ERROR,
        payload: {
          error: 'Oops! Something went wrong',
        },
      });
    }
  } catch (error) {
    dispatch({
      type: types.DOWNLOAD_TRANSACTION_ERROR,
      payload: {
        error,
      },
    });
  }
};

export const downloadCertificate = id => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_CERTIFICATE });
    const response = await DeveloperServices.downloadCertificate(id);
    const file = new Blob([response], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `certifiacte.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
    // if (Object.keys(cleverTapData).length > 0) CleverTapDownload(`certificate_success_download`, cleverTapData);
    dispatch({ type: types.DOWNLOAD_CERTIFICATE_SUCCESS });
  } catch (error) {
    dispatch({
      type: types.DOWNLOAD_CERTIFICATE_ERROR,
      payload: { error: error?.data?.result?.statusCode || error?.message },
    });
  }
};

export const resetPayload = () => dispatch => {
  dispatch({
    type: types.RESET_DEVELOPERS_STATE,
  });
};

export const downloadProgressPdf = (url, name = null) => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_TRANSACTION });
    const file = new Blob([url], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${name}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
    dispatch({ type: types.DOWNLOAD_TRANSACTION_SUCCESS });
  } catch (error) {
    dispatch({
      type: types.DOWNLOAD_TRANSACTION_ERROR,
      payload: {
        error,
      },
    });
  }
};
